import type { BlogPost } from "./types";

/** Public eligibility does not change CMS content or publication state. */
export function isIndexableJournalPost(post: Pick<BlogPost, "status" | "slug" | "title" | "content">): boolean {
  return post.status === "published" && Boolean(post.slug.trim() && post.title.trim() && journalText(post.content));
}

export function journalText(value: string): string {
  return value.replace(/\[([^\]]+)\]\([^)]+\)/g, "$1").replace(/[#*_>`~]/g, "").replace(/\s+/g, " ").trim();
}

export function journalMetadata(post: BlogPost) {
  const headline = post.title.trim();
  const description = post.seo.description.trim() || journalText(post.excerpt) || journalText(post.content).slice(0, 160);
  // Share tags must describe the rendered cover, never an unrelated SEO image.
  const image = post.featuredImage.trim();
  const shareImage = /^https:\/\//i.test(image) ? image : undefined;
  const author = post.authorSlug && post.authorName.trim()
    ? { "@type": post.authorName === "CB16 Atelier" ? "Organization" : "Person", name: post.authorName }
    : undefined;
  return {
    title: post.seo.title.trim() || `${headline} — CB16 Journal`,
    headline,
    description,
    image,
    shareImage,
    author,
    publishedAt: post.publishedAt && Number.isFinite(Date.parse(post.publishedAt)) ? post.publishedAt : undefined,
    slug: post.slug,
  };
}